export default __webpack_public_path__ + "static/media/games-cat.faaac11c.webp";